module.exports = __webpack_public_path__ + "img/about_2010.cf64fda0.png";